<template lang="pug">
  MDashboardWidget( title="Start Status Processing Report" )

    div( class="input-group search-bar" )
      div( class="input-group-prepend" )
        span( class="input-group-addon" )
          select( class="form-control" type="select"  v-model="startTime")
            option( value="60000" ) 1 minute
            option( value="300000" ) 5 minutes
            option( value="1800000" ) 30 minutes
            option( value="3600000" ) 1 Hour

    div( class="row" )
      div( class="col-12 text-right" )
        p Page {{ page }} of {{ lastPageNum }}
        span Per page:&nbsp;
        select( v-model="pageSize" )
          option( value="10" ) 10
          option( value="25" ) 25
          option( value="50" ) 50
          option( value="100" ) 100
        | &nbsp;
        div( class="btn-group" )
          button( class="btn btn-white" v-bind:disabled="page === 1" v-on:click="() => page -= 1" ) Prev page
          button( class="btn btn-white" v-bind:disabled="page === lastPageNum" v-on:click="() => page += 1" ) Next page

    table( v-if="! $apollo.loading" class="table-hover no-margins" )
      thead
        th Start time
          th finished Y/N
            th Batch ID
              th Name / Description
                th user FN LN Company
                  th Audit Report
                    th Actions
      tbody
        tr(v-for="audit in audits.items" )
          td {{ dateFormat(audit.auditedAt, 'dd/mm/yy HH:MM') }}

          td
            span( v-if="audit.status === 'DONE'" class="label label-primary" ) Y 
            span(v-else class="label label-danger") N

          td {{ audit.batch.id.substr(-4) }}

          td( class="audit-name" )
            | {{ audit.batch.name }}
            br
            em {{ audit.batch.description }}

          td
            em( v-if="audit.batch.owner" )
              span {{ audit.batch.owner.name }}
              br
              span( v-if="audit.batch.owner.company" ) {{ audit.batch.owner.company.name }}

          td 
            router-link( v-bind:to="`/reporting/batches/${audit.batch.id}/audits/${audit.id}/output-report`" target="_blank") {{ `/reporting/batches/${audit.batch.id}/audits/${audit.id}/output-report` }}
          
          td               
            router-link( class="btn btn-details btn-outline btn-info" v-bind:to="`/reporting/batches/${audit.batch.id}/audits/${audit.id}`" target="_blank") Open Audit Technical Page
        
</template>
<script>
import Vue from 'vue'
import * as dateFormat from 'dateformat'
import gql from 'graphql-tag'
export default Vue.extend({
  data () {
    return {
      page: 1,
      pageSize: 10,
      startTime: 60000,
    }
  },
 
  apollo: {

    audits: {
      query: gql`query AuditPaginated ($page: Float!, $pageSize: Float!, $startTime: DateTime!) {
        auditMany(
          filter:{
            auditedAt: {
              greaterThanEqualTo: $startTime
            }
          }
          page: $page
          perPage: $pageSize
          sort: {
            auditedAt: DESC
          }
        ) {
          count
          items{
            batch {
              id
              name
              description 
              owner{
                name
                company{
                  name
                }
              }
              
            }
            assignedTo{
              name
              email
              }
            id
            auditedAt
            status
          }
        }
      }`,
      variables() {
        return {
          page: Number(this.page),
          pageSize: Number(this.pageSize),
          startTime: new Date(Date.now() - Number(this.startTime))
        }
      },
      update: data => data.auditMany,
    }
  },

  computed: {
    lastPageNum() {
      return this.audits ? Math.ceil(this.audits.count / this.pageSize) : '...'
    }
  },
  methods: {
    dateFormat,
      }
})
</script>